import { render } from "./SearchLocation.vue?vue&type=template&id=51405546&scoped=true"
import script from "./SearchLocation.vue?vue&type=script&lang=js"
export * from "./SearchLocation.vue?vue&type=script&lang=js"

import "./SearchLocation.vue?vue&type=style&index=0&id=51405546&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51405546"]])

export default __exports__